<template>
    <div role="radiogroup" aria-label="Theme" class="flex h-8 border border-line-strong text-small font-semibold">
        <button
            v-for="option in options"
            :key="option.value"
            type="button"
            role="radio"
            :aria-checked="current === option.value"
            class="px-2.5 cursor-pointer transition-colors"
            :class="current === option.value ? 'bg-ink text-canvas' : 'text-ink hover:bg-surface'"
            @click="choose(option.value)"
        >
            {{ option.label }}
        </button>
    </div>
</template>

<script lang="ts" setup>
type Theme = 'auto' | 'light' | 'dark'

const options: { value: Theme, label: string }[] = [
    { value: 'auto', label: 'Auto' },
    { value: 'light', label: 'Light' },
    { value: 'dark', label: 'Dark' },
]

const userStore = useUserStore()
const current = computed(() => (userStore.theme || 'auto') as Theme)

// Switches right away and saves in the background; goes back if saving fails
const choose = async (theme: Theme) => {
    const previous = userStore.theme
    if (previous === theme) return
    userStore.theme = theme
    try {
        await apiRequest('POST', '/api/users/updateSelf', { theme })
    } catch (e) {
        console.error(e)
        userStore.theme = previous
    }
}
</script>
